// extracted by mini-css-extract-plugin
export default {"wrapper":"vKZaAT5iQm8r0u2Z8Ho7"};